import { render, staticRenderFns } from "./LancesPorComitente.vue?vue&type=template&id=95a39ebe&"
import script from "./LancesPorComitente.vue?vue&type=script&lang=js&"
export * from "./LancesPorComitente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports